import axios from 'axios';
import { CONFIG } from '@/config.ts';
import { ENV_CONFIG } from '@/envConfig.ts';
import { wait } from '@/common/utils/wait.ts';

export const axiosInstance = axios.create({
  baseURL: ENV_CONFIG.apiBaseUrl + CONFIG.apiPrefix,
  withCredentials: true,
});

axiosInstance.interceptors.request.use(async (request) => {
  if (ENV_CONFIG.apiDebugDelay) {
    await wait(ENV_CONFIG.apiDebugDelay);
  }
  return request;
});
